export const blockNonNativeProps =
  (blockedProperties: string[] | string) => (prop: PropertyKey) =>
    Array.isArray(blockedProperties)
      ? !blockedProperties.includes(String(prop))
      : blockedProperties !== prop;
